import { Spinner, Wrap } from '@chakra-ui/react'
import type { FC } from 'react'

import Folder from '@app/pages/maps/components/folder'
import type { BusinessContextsQuery } from '@graphql/queries'

interface Props {
  loading?: boolean
  folders?: BusinessContextsQuery['businessContexts']
}

const FoldersSectionContent: FC<Props> = ({ loading = false, folders = [] }) => {
  if (loading) {
    return <Spinner />
  }

  if (!folders?.length) {
    return null
  }

  return (
    <Wrap gap={3}>
      {folders.map((folder) => (
        <Folder key={folder.id} folder={folder} />
      ))}
    </Wrap>
  )
}

export default FoldersSectionContent
